import { render, staticRenderFns } from "./primeUserStatistics.vue?vue&type=template&id=00c085e3&"
import script from "./primeUserStatistics.vue?vue&type=script&lang=js&"
export * from "./primeUserStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports